import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Clear';
import DenyIcon from '@material-ui/icons/Block';

export const statuses = {
	pendingSupervisorApproval: 'pendingSupervisorApproval',
	supervisorDenied: 'supervisorDenied',
	supervisorCancelled: 'supervisorCancelled',
	pendingHrApproval: 'pendingHrApproval',
	hrDenied: 'hrDenied',
	hrCancelled: 'hrCancelled',
	userCancelled: 'userCancelled',
	approved: 'approved',
};

export const renderStatus = (status) => {
	if (status === statuses.approved) {
		return (
			<div style={{ display: 'flex', alignItems: 'center', color: 'green' }}>
				<CheckIcon style={{ marginRight: 1, height: 20 }} />
				<strong>{_.startCase(status)}</strong>
			</div>
		);
	} else if (status === statuses.hrDenied || status === statuses.supervisorDenied) {
		return (
			<div style={{ display: 'flex', alignItems: 'center', color: '#E97910' }}>
				<DenyIcon style={{ marginRight: 3, height: 20 }} />
				<strong>{_.startCase(status).replace('Hr ', 'HR ')}</strong>
			</div>
		);
	} else if (
		status === statuses.hrCancelled ||
		status === statuses.supervisorCancelled ||
		status === statuses.userCancelled
	) {
		return (
			<div style={{ display: 'flex', alignItems: 'center', color: '#C99930' }}>
				<CancelIcon style={{ marginRight: 3, height: 20 }} />
				<strong>{_.startCase(status).replace('Hr ', 'HR ')}</strong>
			</div>
		);
	} else {
		return <strong>{_.startCase(status || 'missing').replace('Hr ', 'HR ')}</strong>;
	}
};

export const ptoTypeToDisplay = (type) => {
	const display = {
		ptoPaid: 'PTO Paid',
		ptoPaidSickPaid: 'PTO Paid Sick Pay',
		ptoCashOut: 'PTO Cash Out',
	}[type];
	return display || 'Unknown';
};

export function formatPtoRequestHours(ptoRequest) {
	let totalHours;
	let totalDays;
	let rangeDisplay;
	let rangeSort;
	let lastDay;

	const {
		dateCreated,
		// createdByUserId,
		dateAndHours,
		ptoCashOutTotalHours,
		paidType,
	} = ptoRequest;

	if (paidType === 'ptoCashOut') {
		totalHours = ptoCashOutTotalHours;
		rangeDisplay = '-';
		rangeSort = '-';
		lastDay = moment(dateCreated);
	} else {
		totalHours = _.sumBy(dateAndHours, 'hours');
		totalDays = dateAndHours.length;
		const sortedDateAndHours = _.orderBy(dateAndHours, 'date', 'asc');

		const format = 'ddd M/D/YY';
		const firstDay = moment((_.first(sortedDateAndHours) || {}).date);
		lastDay = moment((_.last(sortedDateAndHours) || {}).date);

		rangeDisplay = `${firstDay.format(format)}`;
		rangeSort = firstDay.format('YYYY-MM-DD');
		if (totalDays >= 2) {
			const lastDay = moment((_.last(sortedDateAndHours) || {}).date);
			rangeDisplay = rangeDisplay + ` - ${lastDay.format(format)}`;
		}
	}
	return {
		totalHours,
		totalDays,
		rangeDisplay,
		rangeSort,
		lastDay,
	};
}

const DWP_USER_ID = 1;
const MARY_ANN_USER_ID = 418;
const ERIKM_USER_ID = 1096;
const CLAUDIA_USER_ID = 879;
const HR_USER_IDS = [DWP_USER_ID, MARY_ANN_USER_ID, ERIKM_USER_ID, CLAUDIA_USER_ID];

export function isPtoHr(authUser) {
	return _.includes(HR_USER_IDS, authUser.userId);
}

const DISPATCH_DEPT_ID = 3;
export function isDispatch(authUser) {
	return _.includes(authUser.companyDepartmentIds, DISPATCH_DEPT_ID);
}
